angular.module('app').controller('CustomersCtrl', function($controller, $scope) {
    "ngInject";

    var main = this;
    main.name = 'user';
    angular.extend(main, $controller('ListCtrl', {'$scope': $scope, 'main': main}));

    main.prepareQuery = function() {
        var params = main._prepareQuery();

        // By default search fields override any eq-fields, but this makes it impossible to search All Customers
        if(main.query.filter && main.query.all_customers) {
            params.q.filters.push({
                'name': 'all_customers',
                'op': 'eq',
                'val': true
            });
        }

        return params;
    };

});
